
export const appRouteItems = [
  {
    route: '/bli-medlem',
    label: 'Bli Medlem',
  },
  {
    route: '/leie',
    label: 'Leie Lokaler',
  },
  {
    route: '/nyheter',
    label: 'Nyheter',
  },
  {
    route: '/kurs',
    label: 'Kurs',
  },
  {
    route: '/seiltilbud',
    label: 'Seiltilbud'
  },
  {
    route: '/info',
    label: 'Info'
  },
]
